export function getCopyrightText() {
    const currentYear = new Date().getFullYear();
    return `© ${currentYear} NeuraTrader. All rights reserved.`;
}

export const navigationLinks = [
    { title: 'Home', url: '/' },

    { title: 'Pricing', url: '/pricing' },
    { title: 'Learn', url: '/learn' },
    { title: 'Contact Us', url: '/contact' },
    { title: 'About', url: '/about' },
];

export const policyLinks = [
    { title: 'Terms and Conditions', url: '/terms-and-conditions' },
    { title: 'Privacy Policy', url: '/privacy-policy' },
    { title: 'Cookie Policy', url: '/cookie-policy' },
];

export const appQuickLinks = [
    { title: 'Dashboard', url: '/dashboard' },
    { title: 'Contact Us', url: '/contact' },
    { title: 'Terms', url: '/terms-and-conditions' },
    { title: 'Privacy', url: '/privacy-policy' },
];

export const socialLinks = [
    { title: 'X', url: 'https://x.com/neuratrader', id: 'x' },
    { title: 'Instagram', url: 'https://instagram.com/neuratrader', id: 'instagram' },
];